export const MONTHS = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"June",
	"July",
	"Aug",
	"Sept",
	"Oct",
	"Nov",
	"Dec"
];

export const WEEK_DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];


export const MARKERS = {
    FIRST_MONTH: Symbol("firstMonth"),
    SECOND_MONTH: Symbol("secondMonth"),
};

export const DATE_TIME_RANGE = "dateTimeRange";